<template>
  <HistorialExpediente
    v-if="vehiculo"
    :vehiculo-id="vehiculo"
    :orden-id="orden"
    :volver="rutaBuscar"
  />
  <HistorialBuscar v-else :q="q" @consulta="alConsultar" />
</template>

<script>
/*
 * Historial: el expediente del vehículo (entrega 1, solo lectura).
 *
 * - /menu/historial?q=…            → Buscar (la búsqueda vive en la URL)
 * - /menu/historial/:vehiculo?orden= → Expediente del auto
 *
 * La ruta del expediente es hija de 'historial' sin componente propio: este
 * contenedor sigue montado al ir y volver, así recuerda la última búsqueda
 * para "Cambiar de auto", y el menú marca Historial en ambas.
 */
import HistorialBuscar from '@/components/Historial/Buscar.vue'
import HistorialExpediente from '@/components/Historial/Expediente.vue'

const texto = (valor) => (typeof valor === 'string' ? valor : '')

export default {
  name: 'Historial',
  components: { HistorialBuscar, HistorialExpediente },
  data() {
    return { ultimaBusqueda: '' }
  },
  computed: {
    vehiculo() {
      return texto(this.$route.params.vehiculo)
    },
    orden() {
      return texto(this.$route.query.orden)
    },
    q() {
      return texto(this.$route.query.q)
    },
    rutaBuscar() {
      return { name: 'historial', query: this.ultimaBusqueda ? { q: this.ultimaBusqueda } : {} }
    },
  },
  watch: {
    // En Buscar, la última búsqueda es la de la URL. Al volver desde el menú
    // (sin ?q=) también: así "Cambiar de auto" no regresa a una búsqueda vieja.
    q: {
      immediate: true,
      handler(valor) {
        if (!this.vehiculo) this.ultimaBusqueda = valor
      },
    },
    vehiculo(valor) {
      if (!valor) this.ultimaBusqueda = this.q
    },
  },
  methods: {
    alConsultar(q) {
      this.ultimaBusqueda = q
      if (this.vehiculo || this.q === q) return
      this.$router.replace({ name: 'historial', query: q ? { q } : {} }).catch(() => {})
    },
  },
}
</script>
